module.exports = __webpack_public_path__ + "img/banner-crema-challenge.4d2a773a.png";